module.exports = __webpack_public_path__ + "static/media/edit_icon_button.76bbfca3.svg";